import { useAppSelector } from '../../store/storeHooks';
import { StateSelectorByValue } from '../../types';

const useOurSelectByValue = <T, P>(selector: StateSelectorByValue<T, P>, value: P) =>
  useAppSelector((state) => selector(state, value)) as T;

export default useOurSelectByValue;
